export default function SolutionsSection() {
  const benefits = [
    {
      icon: "ri-drop-line",
      title: "Contrôle Optimal de l'Humidité",
      description: "Maintenez un taux d'hygrométrie idéal pour vos cultures et évitez la condensation excessive.",
      color: "#0066A1"
    },
    {
      icon: "ri-shield-cross-line",
      title: "Réduction des Maladies",
      description: "Limitez drastiquement le développement du botrytis, de l'oïdium et du mildiou dans vos serres.",
      color: "#0066A1"
    },
    {
      icon: "ri-leaf-line",
      title: "Économies d'Énergie",
      description: "Jusqu'à 25% d'économies sur vos coûts de chauffage grâce à une gestion optimisée du climat.",
      color: "#0066A1"
    },
    {
      icon: "ri-line-chart-line",
      title: "Meilleur Rendement",
      description: "Des conditions climatiques stables favorisent la croissance et la qualité de vos productions.",
      color: "#0066A1"
    },
    {
      icon: "ri-settings-3-line",
      title: "Pilotage Automatique",
      description: "Systèmes intelligents avec régulation automatique pour un fonctionnement sans intervention.",
      color: "#0066A1"
    },
    {
      icon: "ri-time-line",
      title: "Durabilité Garantie",
      description: "Équipements professionnels robustes conçus pour un usage intensif en milieu agricole.",
      color: "#0066A1"
    }
  ];

  return (
    <section id="avantages" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Les Avantages de la Déshumidification</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Protégez vos cultures et optimisez votre production avec un contrôle précis de l'hygrométrie
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div 
              key={index} 
              className="flex items-start space-x-4 p-6 rounded-lg hover:bg-gray-50 transition-all duration-300"
            >
              <div 
                className="w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0"
                style={{ backgroundColor: `${benefit.color}15` }}
              >
                <i className={`${benefit.icon} text-2xl`} style={{ color: benefit.color }}></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{benefit.title}</h3>
                <p className="text-gray-600 leading-relaxed">{benefit.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
